import { Platform } from "react-native";

export const bodyFocus = () => {
  if (Platform.OS === "web") {
    document.body.setAttribute("tabIndex", "-1");
    document.body.focus();
  }
};
